import { A11yModule } from "@angular/cdk/a11y";
import { ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit } from "@angular/core";
import { UniversalModalModule } from "@modules/+new/shared/universal-modal/universal-modal.module";
import { CoreModule } from "@modules/core/core.module";
import { WEB3_MERGE_PHASE, Web3Facade, Web3TrackingEventNames } from "@modules/web3/+state/web3.facade";
import { Web3StateService } from "@modules/web3/+state/web3.state.service";
import { Web3NavigationService } from "@modules/web3/services/web3.navigation";
import { StakingEntryHelperService } from "@modules/staking/services/staking-entry.helper.service";
import { TRADE_TYPE } from "@models/trade-offer.model";
import { map, of, switchMap } from "rxjs";

@Component({
	selector: "web3-auto-migrate-success",
	imports: [CoreModule, UniversalModalModule, A11yModule],
	templateUrl: "./web3-auto-migrate-sucess.component.html",
	styleUrl: "./web3-auto-migrate-success.component.scss",
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class Web3AutoMigrateSuccessComponent implements OnInit, OnDestroy {
	private state = inject(Web3StateService);
	private facade = inject(Web3Facade);
	private navigation = inject(Web3NavigationService);
	private stakingEntryHelper = inject(StakingEntryHelperService);

	successSignal = this.state.$successSignal();

	//show staking button
	showStaking$ = this.facade.getVisionTradable$().pipe(
		switchMap((vsn) => {
			if (vsn) {
				return this.facade.getWalletBalanceStatusHelper$(vsn.getId()).pipe(
					map((balance) => {
						if (balance > 0) {
							return vsn.getSymbol();
						}
						return null;
					})
				);
			}
			return of(null);
		})
	);

	ngOnInit(): void {
		//track event
		this.facade.trackEvent(Web3TrackingEventNames.MigrationSuccessScreenViewed, {
			phase: WEB3_MERGE_PHASE.PostMerge,
			migration_estimate: this.successSignal?.amount
		});
	}

	ngOnDestroy(): void {
		//invalidate all
		this.state.invalidateSuccessSignal();
	}

	async next(): Promise<void> {
		await this.navigation.closeModal();
		const asset = this.successSignal?.tradable;

		this.stakingEntryHelper.openStakingFlow(asset.getId(), TRADE_TYPE.STAKE);
	}

	async seeMore(): Promise<void> {
		await this.navigation.closeModal();
		await this.navigation.gotoByPath("/portfolio");
	}
}
